/*
 * @Description: 
 * @Author: yingbin
 * @Date: 2019-08-23 15:43:57
 * @LastEditTime: 2019-09-03 11:10:38
 * @LastEditors: yingbin
 */
import * as types from './mutation-types'
const actions = {
    // changeCount({
    //     commit
    // }) {
    //     commit(types.DO_TEST, 1)
    // },
    // changeCount1({
    //     commit
    // }) {
    //     commit(types.DO_TEST1, 2)
    // }
}
export default actions